import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { RangePicker } from '@modernhealth/vital-components';
import { color, font } from 'src/shared/styles/variables';

const Wrapper = styled.div({
    marginTop: 100,
});

const QuestionText = styled.h4(
    {
        color: color.ebonyClay,
        marginTop: 15,
        marginBottom: 45,
        textAlign: 'center',
    },
    font.black(font.size.extraLarge),
);

const ShareFeedbackText = styled.h5(
    {
        color: color.baliHai,
        textAlign: 'center',
    },
    font.medium(font.size.mediumExtended),
);

const TooEarlyText = styled.p({
    textAlign: 'center',
    padding: 5,
    cursor: 'pointer',
    marginTop: 170,
    marginBottom: 20,
    color: '#77869A',
    ...font.heavy(font.size.mediumExtended),
});

interface Props {
    question: string;
    selectedAnswer: number | null;
    onAnswerClick: (answer: null | number) => void;
}

export const RateSessionRangeQuestion: React.FC<Props> = ({
    question,
    selectedAnswer,
    onAnswerClick,
}) => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            <ShareFeedbackText id="QuestionText">
                {t('videoSessions:rate_session.range_question.title')}
            </ShareFeedbackText>
            <QuestionText>{question}</QuestionText>
            <RangePicker
                labelledBy="QuestionText"
                minLabel={t('videoSessions:rate_session.range_question.disagree')}
                middleLabel={t('videoSessions:rate_session.range_question.neutral')}
                maxLabel={t('videoSessions:rate_session.range_question.agree')}
                onValueChange={onAnswerClick}
                range={5}
                value={selectedAnswer ?? -1}
            />
            <TooEarlyText onClick={() => onAnswerClick(null)}>
                {t('videoSessions:rate_session.range_question.too_early')}
            </TooEarlyText>
        </Wrapper>
    );
};
